import React, { useState,useEffect } from 'react';
import { Container, Grid, Card, CardMedia, CardContent, Typography, Button, Select, MenuItem, IconButton,  CardActionArea } from '@mui/material';
import { Link } from 'react-router-dom';
import axiosInstance from '../common/axios';
import AddToCartButton from '../components/AddToCartButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {fetchSupplierProducts}  from '../service/filterService';
import { styled } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext';
import { requestProductApproval, approveProduct } from '../service/supplierService';
import ProductContainer from './ProductContainer';
import FormInstructionBox from '../components/FormInstructionBox';

const SelectableCard = styled(Card)(({ theme, isSelected }) => ({
  transition: 'transform 0.2s, box-shadow 0.2s, border-color 0.2s',
  border: '2px solid transparent',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    transform: 'translateY(-2px)',
  },
  ...(isSelected && {
    borderColor: theme.palette.primary.main,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  }),
}));


const SupplierVerifyProduct = (supplierData) => {
    
     var [products, setProducts] = useState(null);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  
    const {  userSupplier  } = useAuth();
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
  } = userSupplier || {};
  
  
        const verifyinstructions = [
        "Validate the Added Products before sending for approval.",
        "Select the Products to send for approval. You can select multiple products for approval.",
        "If you have any questions or need more help. Please contact the System Administrator.WhatsApp or Phone: +91 999 464 1128",
        "Click 'Send For Approval' to send the products for Approval."
    ];
  
  useEffect(() => { 
  }, []);
  
      async function  updateProducts() {
      
    const res = await requestProductApproval(supplierData.data.supplierId, selectedProductIds);
 setProducts(res.data);
      console.log("res "+ res);
        console.log("res data: "+ res.data);
    }
  
  return ( 
<>
    
                <FormInstructionBox 
                instructions={verifyinstructions} 
                title="Verify Product Guidelines" 
            />
    <ProductContainer supplierId={supplierData.data.supplierId}   selectedProducts={(updatedProductIds) => setSelectedProductIds(updatedProductIds)}  productList={products} />
          
            <Grid>
              <Button variant="contained" onClick={() => updateProducts()}>
      Sent to Approval
    </Button>
    </Grid>
</>
    )}


export default SupplierVerifyProduct;
